import { Directive, ElementRef, Input, OnChanges, Renderer2, inject } from '@angular/core';

import { getHighlightSegments } from '../utils/highlight-search.utils';

@Directive({
  selector: '[laHighlightSearch]',
})
export class HighlightSearchDirective implements OnChanges {
  @Input({ required: true }) laHighlightSearch!: string;
  @Input() laHighlightSearchQuery = '';

  private elementRef = inject(ElementRef<HTMLElement>);
  private renderer = inject(Renderer2);

  ngOnChanges() {
    this.render();
  }

  private render() {
    const element = this.elementRef.nativeElement;

    while (element.firstChild) {
      this.renderer.removeChild(element, element.firstChild);
    }

    const segments = getHighlightSegments(this.laHighlightSearch, this.laHighlightSearchQuery);

    segments.forEach((segment) => {
      if (segment.highlighted) {
        const strong = this.renderer.createElement('strong');
        this.renderer.setStyle(strong, 'font-weight', '600');
        this.renderer.appendChild(strong, this.renderer.createText(segment.text));
        this.renderer.appendChild(element, strong);
        return;
      }

      this.renderer.appendChild(element, this.renderer.createText(segment.text));
    });
  }
}
